import { Icon } from "components/common"
import { t } from "i18next"
import DateTime from "utils/dateTime"

export const pipelineScopeSegmentOptions = () => [
  { label: t("Sales Pipeline"), value: "salesPipeline" },
  { label: t("Wealth Pipeline"), value: "wealthPipeline" },
]

export const segmentOptions = () => [
  {
    label: t("Board"),
    value: "board",
    icon: <Icon icon={"SvgIcPipeLine"} size="16px" />,
  },
  { label: t("Insights"), value: "insights", icon: <Icon icon={"IoDocumentTextOutline"} size="16px" /> },
]

export const initialQueryObj = {
  month: DateTime.getDateAndTime().startOf("month").format("YYYY-MM-DD"),
  page: 0,
  pageLimit: 10,
  pageIndex: 0,
  sort: "Date Added Descending",
  pipelineType: "sales",
}

export function getPipelineDefaultQuery(pipelineType = "sales") {
  const isWealth = pipelineType === "wealth"
  const { month: _month, ...queryWithoutMonth } = initialQueryObj
  return {
    ...(isWealth ? queryWithoutMonth : initialQueryObj),
    pipelineType,
    ...(isWealth && { stages: WEALTH_PIPELINE_STAGES }),
  }
}

export const WEALTH_PIPELINE_STAGES =
  "wm_prospect,wm_introduction,wm_initial_deal_info_shared,wm_investor_review,wm_client_requirements,wm_mature,wm_active_deal_discussion,wm_information_requested,wm_investor_due_diligence,wm_soft_approval,wm_pre_closure,wm_offer_proposed,wm_mou_signed,wm_execution,wm_deal_structuring"

export const WEALTH_PIPELINE_STAGES_MAX_PARENT_COLUMNS = 4
